import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { base_path } from "./environment";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/style/css/feather.css";
import "../src/index.scss";
import store from "./core/data/redux/store";
import { Provider } from "react-redux";
import "../src/style/icon/boxicons/boxicons/css/boxicons.min.css";
import "../src/style/icon/weather/weathericons.css";
import "../src/style/icon/typicons/typicons.css";
import "../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
import "../src/style/icon/ionic/ionicons.css";
import "../src/style/icon/tabler-icons/webfont/tabler-icons.css";
import ALLRoutes from "./feature-module/router/router";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import { ToastContainer } from "react-toastify";
// import { MsalProvider } from "@azure/msal-react";
// import { msalConfig } from "./authConfig";
// import { PublicClientApplication } from "@azure/msal-browser";

// if (!window.crypto || !window.crypto.subtle) {
//   console.warn("MSAL requires a secure browser environment with window.crypto.subtle support.");
//   console.warn("Make sure you're using HTTPS and a modern browser.");
// }


// const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
  // <MsalProvider instance={msalInstance}>
  <Provider store={store}>
    {/* <BrowserRouter basename={base_path}> */}
    <BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} />
      <ALLRoutes />
    </BrowserRouter>
  </Provider>
//  </MsalProvider>
  // </React.StrictMode>
);
